import React from "react";
import { NavLink } from "react-router-dom";
import {
  Activity, Cpu, Factory, Droplets, Leaf, Target,
  MessageSquare, Sliders
} from "lucide-react";

const NAV = [
  { to: "/", label: "Plant Value Center", icon: Activity, exact: true },
  { to: "/operations", label: "Operations Center", icon: Factory },
  { to: "/resources", label: "Resource Intelligence", icon: Droplets },
  { to: "/sustainability", label: "Sustainability Center", icon: Leaf },
  { to: "/opportunities", label: "Opportunity Center", icon: Target },
  { to: "/advisor", label: "AI Advisor", icon: MessageSquare },
  { to: "/simulation", label: "Simulation Studio", icon: Sliders },
];

export default function Sidebar() {
  return (
    <aside className="oim-sidebar" data-testid="sidebar">
      <div className="sidebar-logo">
        <img src="/assets/ergoniq-logo.svg" alt="Ergoniq" data-testid="ergoniq-logo" />
      </div>
      <div className="sidebar-section">Chemical OIM</div>
      <nav className="sidebar-nav">
        {NAV.map(({ to, label, icon: Icon, exact }) => (
          <NavLink
            key={to}
            to={to}
            end={!!exact}
            className={({ isActive }) => "sidebar-link" + (isActive ? " active" : "")}
            data-testid={`nav-${to.replace(/\//g, "-") || "home"}`}
          >
            <Icon strokeWidth={1.6} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <div style={{ padding: "10px 16px", borderTop: "1px solid var(--border-soft)" }}>
        <div className="mono" style={{ fontSize: 9, color: "var(--text-mute)", letterSpacing: "0.18em", textTransform: "uppercase" }}>
          Build · Prototype v1.0
        </div>
      </div>
    </aside>
  );
}
